const baseUrl = 'https://api.app.deas.dk/addresses';

/**
 * Constructs the URL for searching addresses.
 * @param {HTMLFormElement} form
 * @returns {String}
 */
const getSearchUrl = ( form ) => {
	const formData = new FormData( form );
	const params = new URLSearchParams( formData );
	return `${ baseUrl }?${ params.toString() }`;
}

let abortController = null;

/**
 * Search for addresses based on the provided query.
 * @param {HTMLFormElement} form
 * @returns {Promise<AddressResult[]>}
 */
export const searchAddress = async ( form ) => {
	if ( abortController ) {
		abortController.abort( 'New search initiated, aborting previous request.' );
	}

	abortController = new AbortController();

	try {
		const results = await fetch( getSearchUrl( form ), {
			signal: abortController.signal,
		} );
		return await results.json();
	} catch ( error ) {
		console.error( 'Error fetching address:', error );
	}

	return [];
}
